import React, { useState } from "react";
import {
  FiClipboard,
  FiBarChart2,
  FiUser,
} from "react-icons/fi";

import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import RepresentativeSettlementPage from "./RepresentativeSettlementPage";
import PaymentMethods from "./PaymentMethods";
import Representatives from "./Representatives";

const RepresentativeSettlement = () => {
  const [activePage, setActivePage] = useState("settlement");

  return (
    <div className="apDiv ChatApp min-h-screen bg-slate-50">
      <Sidebar />

      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>

        <main className="px-4 py-6 md:px-6 lg:px-8">
          {/* PAGE HEADER */}
          <div className="mb-4">
            <h1 className="text-xl font-bold text-slate-800">
              تسوية المندوبين
            </h1>
            <p className="mt-1 text-xs text-slate-500">
              إدارة ومراجعة تسويات المندوبين ووسائل الدفع وحسابات المناديب
            </p>
          </div>

          {/* MAIN PAGE TABS - SAME COMPACT DESIGN */}
          <div className="mb-6 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
            <div className="grid grid-cols-3">
              <button
                type="button"
                onClick={() => setActivePage("settlement")}
                className={`flex items-center justify-center gap-2 border-l border-slate-200 px-4 py-3 text-sm font-bold transition ${
                  activePage === "settlement"
                    ? "bg-blue-600 text-white"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <FiClipboard className="text-sm" />
                تسوية المندوب
              </button>

              <button
                type="button"
                onClick={() => setActivePage("payment")}
                className={`flex items-center justify-center gap-2 border-l border-slate-200 px-4 py-3 text-sm font-bold transition ${
                  activePage === "payment"
                    ? "bg-blue-600 text-white"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <FiBarChart2 className="text-sm" />
                وسائل الدفع
              </button>

              <button
                type="button"
                onClick={() => setActivePage("representative")}
                className={`flex items-center justify-center gap-2 px-4 py-3 text-sm font-bold transition ${
                  activePage === "representative"
                    ? "bg-blue-600 text-white"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <FiUser className="text-sm" />
                المندوب
              </button>
            </div>
          </div>

          {activePage === "settlement" ? (
            <RepresentativeSettlementPage />
          ) : activePage === "payment" ? (
            <PaymentMethods embedded />
          ) : (
            <Representatives />
          )}
        </main>
      </div>
    </div>
  );
};

export default RepresentativeSettlement;
